import { useUserContext } from "../../contexts/usercontext";
import React, { useEffect, useRef, useState } from "react";
import useTable from "../../hooks/useTable";
import Services from "../../../services";
import Toaster from "../../../services/toaster";
import { Button, Input, Modal, Space, Table } from "antd";
import { DeleteOutlined, ExclamationCircleOutlined, FileImageOutlined, LikeOutlined } from "@ant-design/icons";
import Helpers from "../../../services/helpers";
import { ALT_CAMPAIGN } from "../../../globals";
import { entityImageModal, setFileImage, toggleAuctionInclusion } from "../../layouts/ActiveResultsList";
import { isEmpty } from "lodash";
import useFirstMountState from "../../hooks/useFirstMountState";

const ButtonGroup = Button.Group;

const getColumns = (isAdmin, showModal, setFlaggedData, user, refresh) => [
  {
    title: "Listing Image",
    key: "imageUrl",
    width: 100,
    render: (text, record) => {
      return (
        <>
          <span className="hidden-desktop inline-table-label">Listing Image: </span>
          {record.imageUrl && (
            <a
              href={Helpers.generatePartnerLinkFromAuctionURL(record.auction_url)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img width={75} src={record.imageUrl} alt={record.title} />
            </a>
          )}
        </>
      );
    },
  },
  {
    title: "Card Image",
    key: "entityImageUrl",
    width: 100,
    render: (text, record) => {
      return (
        <>
          <span className="hidden-desktop inline-table-label">Card Image: </span>
          <a
            onClick={() => {
              record.entityImageUrl ? entityImageModal(record.entityImageUrl) : null;
            }}
          >
            <img width={75} src={record.entityImageUrl ? record.entityImageUrl : "/no-image.png"} alt={record.title} />
          </a>
        </>
      );
    },
  },
  {
    title: "Listing Title (Click to open on eBay)",
    dataIndex: "title",
    key: "title",
    width: 300,
    render: (text, record) => {
      const style = {};

      if (record.partnerLink) {
        style.fontWeight = "bold";
      }

      return (
        <>
          <span className="hidden-desktop inline-table-label">Listing Title: </span>
          <a
            href={
              record.partnerLink ? record.partnerLink : Helpers.generatePartnerLinkFromAuctionURL(record.auction_url)
            }
            target="_blank"
            rel="noopener noreferrer"
            style={style}
          >
            {record.partnerLink ? "Click to See Auctions Ending Soon" : record.title}
          </a>
        </>
      );
    },
  },
  {
    title: "Accept Offers",
    dataIndex: "best_offer_enabled",
    key: "best_offer_enabled",
    width: 100,
    render: (value) => {
      return (
        <>
          <span className="hidden-desktop inline-table-label">Accepting Offers: </span>
          {value != null && <span>{value ? "yes" : "no"}</span>}
        </>
      );
    },
  },
  {
    title: "Buy It Now Price",
    dataIndex: "buy_it_now_price",
    key: "buy_it_now_price",
    width: 115,
    render: (text, record) => (
      <>
        <span className="hidden-desktop inline-table-label">Price: </span>
        {record.buy_it_now_price && (
          <>
            {Helpers.formatMoney(record.buy_it_now_price)}
            {Number(record.buy_it_now_price_change_percentage) <= 10 && <LikeOutlined />}
          </>
        )}
      </>
    ),
    defaultSortOrder: "ascend",
    sorter: () => null,
  },
  {
    title: "Compared to Last Avg Sale ($)",
    dataIndex: "buy_it_now_price_change",
    key: "buy_it_now_price_change",
    width: 115,
    render: (val) => (
      <>
        <span className="hidden-desktop inline-table-label">Compared to Last Avg Sale ($)</span>
        {val && (
          <span
            style={{
              color: val >= 0 ? "black" : "red",
            }}
          >
            {Helpers.formatMoney(val)}
          </span>
        )}
      </>
    ),
    sorter: () => null,
  },
  {
    title: "Compared to Last Avg Sale (%)",
    dataIndex: "buy_it_now_price_change_percentage",
    key: "buy_it_now_price_change_percentage",
    width: 115,
    render: (val) => (
      <>
        <span className="hidden-desktop inline-table-label">Compared to Last Avg Sale (%)</span>
        {val && (
          <span
            style={{
              color: val >= 0 ? "black" : "red",
            }}
          >
            {val}%
          </span>
        )}
      </>
    ),
    sorter: () => null,
  },
  ...(isAdmin
    ? [
        {
          title: "Remove & Report",
          key: "flag",
          width: 100,
          render: (text, record) =>
            record.partnerLink ? null : (
              <Space>
                <Button
                  type={"warning"}
                  onClick={() => {
                    showModal();
                    setFlaggedData({
                      user_id: user.id,
                      card_id: record.card_id,
                      auction_id: record.auction_id,
                      active_result_id: record.key,
                    });
                  }}
                >
                  <ExclamationCircleOutlined />
                </Button>
              </Space>
            ),
        },
        {
          title: "Admin",
          key: "admin",
          width: 75,
          render: (text, record) =>
            record.partnerLink ? null : (
              <ButtonGroup>
                <Button
                  type={"danger"}
                  onClick={() => {
                    Modal.confirm({
                      title: "PERMANENTLY DELETE THIS SALE, ARE YOU SURE?",
                      okText: "Yes",
                      okType: "danger",
                      cancelText: "No",
                      onOk() {
                        toggleAuctionInclusion(record.key, false, refresh);
                      },
                    });
                  }}
                >
                  <DeleteOutlined />
                </Button>

                <Button
                  onClick={() => {
                    Modal.confirm({
                      title: "Are you sure you want to set this as the ADMIN photo?",
                      okText: "Yes",
                      okType: "danger",
                      cancelText: "No",
                      onOk() {
                        setFileImage(record.card_id, record.auction_id);
                      },
                    });
                  }}
                >
                  <FileImageOutlined />
                </Button>
              </ButtonGroup>
            ),
        },
      ]
    : []),
];

const PopularResultPanel = ({
  entity,
  entityType,
  type,
  results,
  totalCount,
  refresh,
  onPaginationChange,
  statsForCard,
}) => {
  const { user } = useUserContext();
  const [flaggedData, setFlaggedData] = useState({});
  const [reportReason, setReportReason] = useState("");
  const [visible, setVisible] = useState(false);
  const input = useRef();
  const { tableProps, pageSize, currentPage, sortBy } = useTable({
    defaultPageSize: 10,
    totalCount,
    initialSort: {
      sortBy: "buy_it_now_price",
      orderBy: "asc",
    },
  });
  const isFirstMount = useFirstMountState();

  useEffect(() => {
    // This sortBy is fixed in place because any of the 3 sortable columns you choose to order refer to the same base criteria
    if (!isFirstMount) {
      onPaginationChange(
        entity.id,
        { limit: pageSize, skip: currentPage - 1 },
        isEmpty(sortBy) ? {} : { sortBy: "buy_it_now_price", orderBy: sortBy.orderBy },
      );
    }
  }, [pageSize, currentPage, sortBy]);

  const showModal = () => {
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
    setReportReason("");
  };

  const handleReasonChange = (event) => {
    setReportReason(event.target.value);
  };

  const saveFlaggedData = async () => {
    try {
      await Services.createFlaggedAuction({
        ...flaggedData,
        reason: reportReason,
      });
      toggleAuctionInclusion(flaggedData.active_result_id, false, refresh);
      Toaster.SuccessNotification("Successfully reported entity.");
    } catch (e) {
      Toaster.ErrorNotification("Error occurred reporting entity.");
    }
    hideModal();
  };

  const [label, identifier] = {
    CARD: ["Card", "card_id"],
    SEALED_WAX: ["Wax", "sealed_wax_id"],
  }[entityType];

  const data = results.map((result) => {
    const endAverage = statsForCard ? statsForCard.endAvg : 0;
    const priceChange = (result.buy_it_now_price - endAverage).toFixed(2);
    const priceChangePercent = ((endAverage > 0 ? priceChange / endAverage : 0) * 100).toFixed(2);

    return {
      [identifier]: entity.id,
      key: result.id,
      auction_id: result.auction_id,
      title: result.title,
      end_time: result.end_time,
      imageUrl: result.image_url,
      entityImageUrl: Helpers.pickMmImage(entity),
      auction_url: result.auction_url,
      price: result.selling_price,
      price_change: endAverage - result.selling_price,
      price_change_percent: Helpers.getPercentChanged(result.selling_price, endAverage),
      offer_price: result.offer_price,
      auction_type: result.auction_type ? result.auction_type : Helpers.calculateResultType(result),
      offer_price_message: result.offer_price_message,
      number_of_bids: result.number_of_bids,
      buy_it_now_available: result.buy_it_now_available,
      buy_it_now_price: result.buy_it_now_price,
      buy_it_now_price_change: priceChange,
      buy_it_now_price_change_percentage: priceChangePercent,
      buy_it_now_currency: result.buy_it_now_currency,
      best_offer_enabled: result.best_offer_enabled,
      endAverage,
    };
  });

  if (type === "fixed" && currentPage === 1) {
    data.unshift({
      key: entity.id,
      entityImageUrl: Helpers.pickMmImage(entity),
      partnerLink: Helpers.generatePartnerLinkFromQuery(ALT_CAMPAIGN, entity.query, "active"),
    });
  }

  const columns = getColumns(user.is_admin, showModal, setFlaggedData, user, refresh);

  return (
    <>
      {data && data.length ? (
        <Table
          className="ant-table-mobile"
          columns={columns}
          dataSource={data}
          scroll={{ y: "80vh", x: true }}
          {...tableProps}
        />
      ) : null}
      <Modal
        width={800}
        title="Remove & Report"
        visible={visible}
        onOk={saveFlaggedData}
        okText="Yes, Remove"
        onCancel={hideModal}
      >
        <p>Are you sure this {label} does not match the search?</p>
        <div>Clicking yes will temporarily remove this {label} and report it to the admin for permanent removal.</div>
        <div>
          Reason: <Input inputRef={input} type={"text"} value={reportReason} onChange={handleReasonChange} />
        </div>
      </Modal>
    </>
  );
};

export default PopularResultPanel;
